<template>
  <div :class="{ 'dark-mode': isDarkMode }">
    <nav>
      <v-app-bar :color="isDarkMode ? '#111827' : 'white'" :elevation="0">
        <Workspace class="d-none" />
        <div class="navbar-content">

          <div class="navbar-text">{{ menuTitle }}</div>

          <div class="navbar-right-sec">
            <!-- <v-menu rounded offset-y>
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon class="mr-1">
                  <v-avatar size="20">
                    <v-img
                      src="../../../assets/Images/Navbar/settings.png"
                    ></v-img>
                  </v-avatar>
                </v-btn>
              </template>
<v-card v-if="getTenantData && getTenantData.length > 1">
  <v-card-text>
    <v-btn rounded variant="text" @click="openModal">
      Change tenant
    </v-btn>
  </v-card-text>
</v-card>
</v-menu> -->

            <!-- <v-btn icon class="mr-1">
              <v-badge content="2">
                <v-avatar size="20">
                  <v-img
                    src="../../../assets/Images/Navbar/notification.png"
                  ></v-img>
                </v-avatar>
              </v-badge>
            </v-btn> -->

            <!-- <v-text-field
              :loading="loading"
              density="compact"
              variant="solo"
              label="Sample Search Query"
              prepend-inner-icon="mdi-magnify"
              single-line
              hide-details
              @click:append-inner="onClick"
            ></v-text-field>

            <v-btn class="setting-btn">
                <v-avatar size="24">
                  <v-img
                    src="../../../assets/Images/Navbar/settings.png"
                  ></v-img>
                </v-avatar>
            </v-btn>

            <v-btn class="setting-btn">
                <v-avatar size="24">
                  <v-img
                    src="../../../assets/Images/Navbar/notification.png"
                  ></v-img>
                </v-avatar>
            </v-btn> -->

            <!-- <v-divider class="vertical-divider"
              thickness="2"
              vertical
            ></v-divider> -->
            <v-avatar size="45" class="dark-mode-toggle">
              <v-img
                @click="toggleDarkMode"
                :src="isDarkMode ? currentIcons.lightmode : currentIcons.darkmode"
                alt="dark mode"
              />
            </v-avatar>

            <v-menu
              v-if="userPermissions.includes('ManageUsers') || userPermissions.includes('ManageRoles')"
              location="bottom end"
              :offset="8"
              content-class="settings-dropdown-overlay"
            >
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="variant" class="security-btn">
                  <v-avatar size="20">
                    <v-img :src="currentIcons.settings" alt="security" :class="{ 'dark-mode-icon': isDarkMode }"></v-img>
                  </v-avatar>
                </v-btn>

              </template>
              <v-card class="settings-dropdown-menu" elevation="0">
                <v-card-text class="settings-dropdown-body">
                  <button
                    v-if="userPermissions.includes('ManageUsers')"
                    type="button"
                    class="settings-dropdown-item"
                    @click="redirectToUsers"
                  >
                    <v-avatar size="22" class="settings-dropdown-icon">
                      <v-img :src="currentIcons.userMode" alt="Users"></v-img>
                    </v-avatar>
                    <span>User Management</span>
                  </button>
                  <button
                    v-if="userPermissions.includes('ManageRoles')"
                    type="button"
                    class="settings-dropdown-item"
                    @click="redirectToRoles"
                  >
                    <v-avatar size="22" class="settings-dropdown-icon">
                      <v-img :src="currentIcons.roleMode" alt="Roles"></v-img>
                    </v-avatar>
                    <span>Role Management</span>
                  </button>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-menu rounded v-model="userMenuOpen">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="variant" class="user-dropdown">
                  <v-avatar width="32px" height="32px" style="height: 32px; width: 32px;">
                    <v-img :src="user?.profileImage" alt="profile"></v-img>
                  </v-avatar>
                  <h5 class="user-name">{{ userFullName }}</h5>
                  <v-avatar size="20">
                    <v-img 
                      :src="currentIcons.chevronDown" 
                      alt="arrow down"
                      :class="{ 'dark-mode-icon': isDarkMode }"
                    ></v-img>
                  </v-avatar>
                </v-btn>
              </template>
              <v-card class="user-dropdown-menu">
                <v-card-text>
                  <div class="mx-auto text-center">
                    <v-avatar size="40">
                      <v-img :src="user?.profileImage" alt="profile"></v-img>
                    </v-avatar>
                    <h5 class="user-name">{{ userFullName }}</h5>
                    <p class="text-email">
                      {{ userEmail }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <!-- <v-btn rounded variant="text"> Edit Account </v-btn> -->
                    <v-btn rounded variant="text" class="user-menu" @click="openModal">
                      Change tenant
                    </v-btn>
                    <v-divider class="my-2"></v-divider>
                    <v-btn rounded variant="text" class="user-menu logout-btn" @click="logOut">
                      Logout
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>

            <!-- <v-avatar size="36" rounded="0" class="ml-1 filter-btn">
              <v-img src="../../../assets/Images/Navbar/grid.png"></v-img>
            </v-avatar> -->
          </div>
        </div>
        <Links />
      </v-app-bar>
    </nav>
    <v-dialog v-model="showModal" max-width="600" class="tenant-dialog">
      <v-card>
        <v-card-title class="px-0 d-flex align-center justify-between">Tenant Data
          <v-spacer></v-spacer>
          <v-btn @click="closeModal" flat icon class="chart-preview-close-btn" size="x-small">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 200px">
          <v-select v-if="getTenantData && getTenantData.length > 1" @update:modelValue="onSelectTenant"
            :model-value="getSelectedTenant?.name || ''" :items="getTenantData.map((tenant) => tenant.name)"
            placeholder="Please select tenant">
          </v-select>
          <v-list v-else>
            <v-list-item> No tenant data available. </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :model-value="overlay" class="align-center logout-loader justify-center">
      <v-progress-circular color="primary" size="48" indeterminate></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="getLogoutError">
      <div class="text-center" v-html="getLogoutError"></div>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Workspace from "./Workspace.vue";
import Links from "./Links.vue";
import { mapActions } from "vuex";
import { getTenantPrefix } from "../../../utils/tenant.js";
export default {
  data: () => ({
    user: {
      fullName: "John Doe",
      email: "johndoe@gmail.com",
      profileImage: require("../../../assets/Images/Navbar/profile.png"),
    },
    userMode: require("../../../assets/Svg/profile.svg"),
    roleMode: require("../../../assets/Svg/role-module.svg"),
    settingIcon: require("../../../assets/Svg/setting-2.svg"),
    showModal: false,
    drawer: false,
    group: null,
    overlay: false,
    snackbarMessage: null,
    timeoutMessage: "",
    localStorageMenuTitle: localStorage.getItem("activeMenu") || "Data Management",
    selectedTenantId: "",
    userMenuOpen: false,
  }),
  components: {
    Workspace,
    Links,
  },
  computed: {
    ...mapGetters("auth", ["getExpirationTime"]),
    ...mapGetters("tenantId", ["getTenantData", "getSelectedTenant", "getUser"]),
    userPermissions() {
      return this.getUser?.permissions?.map(permission => permission.name) || [];
    },
    isAdmin() {
      return this.getUser && (this.getUser.role === "Administrator" || this.getUser.role === "SuperAdmin");
    },
    userFullName() {
      if (this.getUser && this.getUser.firstName && this.getUser.lastName) {
        return `${this.getUser.firstName} ${this.getUser.lastName}`;
      }
    },
    menuTitle() {
      const path = this.$route?.path || "";
      const tenant = this.tenantId;

      if (tenant && path.startsWith(`/${tenant}/agentic-dashboard`)) {
        const n = this.$route.name;
        if (n === "AgenticDashboardAll") {
          return "Agentic Dashboard · All";
        }
        if (n === "AgenticDashboardStarred") {
          return "Agentic Dashboard · Starred";
        }
        if (n === "AgenticDashboardShared") {
          return "Agentic Dashboard · Shared";
        }
        return "Agentic Dashboard";
      }

      if (this.localStorageMenuTitle === "Exploratory Data Analysis") {
        return "Exploratory Data Analysis (EDA)";
      }
      if (tenant && path.startsWith(`/${tenant}/assets`)) {
        return "Data Management";
      }
      if (tenant && path.startsWith(`/${tenant}/Dashboards`)) {
        return "Dashboards";
      }
      if (this.localStorageMenuTitle === "PVT Data Visualization") {
        return "Data Management";
      }
      return this.localStorageMenuTitle;
    },
    userEmail() {
      return this.getUser?.username;
    },
    tenantId() {
      return this.$route.path.split("/")[1] || getTenantPrefix();
    },
    getLogoutError() {
      const error = this.$store.getters["auth/getLogoutError"];
      if (error) {
        this.snackbarMessage = error;
      }
      return error;
    },
    isDarkMode() {
      return this.$store.getters["darkMode/isDarkMode"];
    },
    currentIcons() {
      if (this.isDarkMode) {
        return {
          chevronDown: require("../../../assets/Images/Navbar/chevron down.png"),
          settings: require("../../../assets/Svg/setting-2.svg"),
          userMode: require("../../../assets/Svg/profile.svg"),
          roleMode: require("../../../assets/Svg/role-module.svg"),
          changePass: require("../../../assets/Svg/changePass.svg"),
          security: require("../../../assets/Svg/setting-2.svg"),
          darkmode: require("../../../assets/Svg/moon.svg"),
          lightmode: require("../../../assets/Svg/sun.svg"),
        };
      }
      return {
        chevronDown: require("../../../assets/Images/Navbar/chevron down.png"),
        settings: require("../../../assets/Svg/setting-2.svg"),
        userMode: require("../../../assets/Svg/profile.svg"),
        roleMode: require("../../../assets/Svg/role-module.svg"),
        changePass: require("../../../assets/Svg/changePass.svg"),
        security: require("../../../assets/Svg/setting-2.svg"),
        darkmode: require("../../../assets/Svg/moon.svg"),
        lightmode: require("../../../assets/Svg/sun.svg"),
      };
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    ...mapActions("auth", ["sendLogoutRequest"]),
    async setTenantFromUrl() {
      const urlSegment = window.location.pathname.split("/")[1]; // Get first segment from URL
      const matchedTenant = this.getTenantData.find(tenant => tenant.ID === urlSegment);
      this.selectedTenantId = matchedTenant?.ID;
      const name = matchedTenant?.name;
      const ID = matchedTenant?.ID
      await this.$store.commit("tenantId/SET_SELECTED_TENANT", { name, ID });
    },
    openModal() {
      this.showModal = true;
    },
    redirectToUsers() {
      localStorage.setItem("activeMenu", "User Management");
      this.$router.push(`/${this.selectedTenantId}/users`);
    },
    redirectToRoles() {
      localStorage.setItem("activeMenu", "Role Management");
      this.$router.push(`/${this.selectedTenantId}/roles`);
    },
    logOut() {
      this.overlay = true;
      this.timeoutMessage = ''
      this.sendLogoutRequest()
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            this.overlay = false;
            window.location.reload();
            this.$router.push("/login");
          }
        })
        .finally(() => {
          this.overlay = false;
        })
    },
    toggleDarkMode() {
      this.$store.commit("darkMode/toggleDarkMode");
    },
    async callTenants() {
      if (localStorage.getItem("authToken")) {
        await this.$store.dispatch("tenantId/fetchTenants");
        this.setTenantFromUrl();
      }
    },
    closeModal() {
      this.showModal = false;
    },
    onIframePointerMessage(event) {
      if (event?.data?.type === "FLUIDSDATA_IFRAME_POINTER") {
        this.userMenuOpen = false;
      }
    },
    async onSelectTenant(selectedValue) {
      const selectedTenant = this.getTenantData.find(
        (tenant) => tenant.name === selectedValue
      );

      if (selectedTenant) {
        const { name, ID } = selectedTenant;
        localStorage.removeItem('lastVisitedDashboard');
        localStorage.removeItem('savedChartData');
        localStorage.removeItem('lastFilterId');
        this.selectedTenantId = ID;

        await this.$store.commit("tenantId/SET_SELECTED_TENANT", { name, ID });

        const segments = (this.$route.path || "").split("/").filter(Boolean);
        const stayOnPvt = segments[1] === "pvt-prediction";
        this.$router.push(stayOnPvt ? `/${ID}/pvt-prediction` : `/${ID}/data-management`);

        this.closeModal();
      }
    },
    updateMenuTitle() {
      const activeMenu = localStorage.getItem("activeMenu") || "Data Management";
      const normalizedActiveMenu =
        activeMenu === "PVT Data Visualization" ? "Data Management" : activeMenu;
      const routePath = this.$route.path;
      const tenant = this.tenantId;

      if (tenant && routePath.startsWith(`/${tenant}/assets`)) {
        this.localStorageMenuTitle = "Data Management";
        return;
      }

      if (tenant && routePath.startsWith(`/${tenant}/Dashboards`)) {
        this.localStorageMenuTitle = "Dashboards";
        return;
      }

      if (tenant && routePath.startsWith(`/${tenant}/agentic-dashboard`)) {
        this.localStorageMenuTitle = "Agentic AI Dashboards";
        return;
      }

      if (["/assets", "/data-management", "/Fluidsdata-studio", "/Dashboards", "/exploratory-data-analysis", "/pvt-prediction", "/users", "/roles"].includes(routePath)) {
        const pathSegments = this.$route.path.split('/').filter(Boolean);
        const mainRoute = pathSegments.length > 1 ? `/${pathSegments[1].toLowerCase()}` : null;

        const validRoutes = [
          "/assets",
          "/data-management",
          "/fluidsdata-studio",
          "/dashboards",
          "/exploratory-data-analysis",
          "/pvt-prediction"
        ];

        if (mainRoute && validRoutes.includes(mainRoute)) {
          this.localStorageMenuTitle = normalizedActiveMenu;
        }
      }

      const storedMenu = localStorage.getItem("activeMenu");
      this.localStorageMenuTitle = storedMenu
        ? (storedMenu === "PVT Data Visualization" ? "Data Management" : storedMenu)
        : "Data Management";
    }
  },

  mounted() {
    if (localStorage.getItem("activeMenu") === "PVT Data Visualization") {
      localStorage.setItem("activeMenu", "Data Management");
    }
    if (localStorage.getItem("lastActiveMenu") === "PVT Data Visualization") {
      localStorage.setItem("lastActiveMenu", "Data Management");
    }
    this.callTenants();
    this.menuTitleInterval = setInterval(() => {
      this.updateMenuTitle();
    }, 100);
    window.addEventListener("message", this.onIframePointerMessage);
  },
  beforeUnmount() {
    window.removeEventListener("message", this.onIframePointerMessage);
    if (this.menuTitleInterval) {
      clearInterval(this.menuTitleInterval);
    }
  },
};
</script>